import { Module } from "vuex";
import {
  ModalConfigStruct,
  ModalPresetsStruct,
} from "@/struct/ui/UIModalStruct";
import { MODAL_PRESETS, TypesModals } from "@/config/modals";

export interface SystemState {
  activeConfig: ModalConfigStruct | null;
}

const systemModule: Module<SystemState, any> = {
  namespaced: true,
  state: () => ({
    activeConfig: null,
  }),
  getters: {},
  mutations: {
    OPEN_MODAL(state, payload) {
      state.activeConfig = payload;
    },
    CLOSE_MODAL(state) {
      state.activeConfig = null;
    },
    SET_BTN_LOADING_MODAL(
      state,
      payload: { btn: "main" | "secondary"; loading: boolean }
    ) {
      if (state.activeConfig) {
        if (payload.btn === "main") {
          state.activeConfig.mainBtnLoading = payload.loading;
        } else {
          state.activeConfig.secondaryBtnLoading = payload.loading;
        }
      }
    },
  },
  actions: {
    openModal(
      { commit },
      payload: {
        presetKey: TypesModals;
        overrides?: Partial<ModalPresetsStruct>;
        onAction?: () => void;
        onSecondaryAction?: () => void;
      }
    ) {
      const staticPreset = MODAL_PRESETS[payload.presetKey];
      commit("OPEN_MODAL", {
        mainBtnLoading: false,
        secondaryBtnLoading: false,
        ...staticPreset,
        ...payload.overrides,
        onAction: payload.onAction,
        onSecondaryAction: payload.onSecondaryAction,
      });
    },
    closeModal({ commit }) {
      commit("CLOSE_MODAL");
    },
  },
};

export default systemModule;
